import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

const CustomRoute = (props) => {
  const { component: Component, path, exact } = props;

  return (
    <Route
      key={path}
      path={path}
      exact={exact}
      render={(routeProps) => <Component {...routeProps} route={props} />}
    />
  );
};

CustomRoute.propTypes = {
  component: PropTypes.any,
  path: PropTypes.string,
  exact: PropTypes.bool,
  route: PropTypes.string,
};

export default CustomRoute;
